// @flow
import React from 'react';
import _ from 'lodash';
import cn from 'classnames';
import moment from 'moment';
import 'moment/locale/he';
import { EVENT_TYPES } from 'client/constants/common';
import { Icon } from '../../Icon';
import { Responsive } from '../../Responsive';
import css from './Scoreboard.scss';

type Props = {
	stadium: string,
	stadiumVisitors: string,
	league: string,
	date: string,
	homeTeam: string,
	homeTeamLogo: string,
	homeScore: number,
	guestTeam: string,
	guestTeamLogo: string,
	questScore: number,
	refereeName: string,
	refereeGrade: number,
	goalArenaEvents: any[],
};

export function Scoreboard({
	stadium,
	stadiumVisitors,
	league,
	date,
	homeTeam,
	homeTeamLogo,
	homeScore,
	guestTeam,
	guestTeamLogo,
	questScore,
	refereeName,
	refereeGrade,
	goalArenaEvents,
}: Props) {
	const refereeTitle = 'שופט: ';
	const refereeGradeTitle = 'ציון: ';
	// const scoreTitle = 'סיום';
	const dayHE = 'יום';
	const stadiumVisitorsText = `${stadiumVisitors} צופים`;
	const resultedHomePlayers = _.filter(
		goalArenaEvents,
		i =>
			(i.Team === homeTeam && i.Event !== EVENT_TYPES.OWN_GOAL) ||
			(i.Team === guestTeam && i.Event === EVENT_TYPES.OWN_GOAL)
	);
	const resultedGuestPlayers = _.filter(
		goalArenaEvents,
		i =>
			(i.Team === guestTeam && i.Event !== EVENT_TYPES.OWN_GOAL) ||
			(i.Team === homeTeam && i.Event === EVENT_TYPES.OWN_GOAL)
	);
	const isDesktop = Responsive.isMatching(Responsive.DESKTOP);
	const isTablet = Responsive.isMatching(Responsive.TABLET_P) || Responsive.isMatching(Responsive.TABLET_L);

	const renderPlayer = event => {
		return (
			<div className={css.player} key={`${event.Player}-${event.Minute}`}>
				{isDesktop && <Icon type={event.Event} width={22} height={22} />}
				{!isDesktop && <Icon type={event.Event} width={20} height={20} />}
				<span className={css.name}>{event.Player}</span>
				<span className={css.minute}>{`(${event.Minute})`}</span>
			</div>
		);
	};

	return (
		<div className={css.scoreboard}>
			<div className={cn(css.header, !stadiumVisitors && css.noVisitorsInfo)}>
				<p className={css.league}>{league}</p>
				<div className={css.middle}>
					<p className={css.stadium}>{stadium}</p>
					{stadiumVisitors && <p className={css.visitors}>{stadiumVisitorsText}</p>}
				</div>
				<p className={css.date}>
					{`${dayHE} ${moment(date)
						.locale('he')
						.format('dddd')}`}
					, {moment(date).format('DD/MM/YYYY')}, {moment(date).format('HH:mm')}
				</p>
			</div>
			<div className={css.main}>
				{!isDesktop && !isTablet && (
					<div className={css.teamNames}>
						<p className={css.teamName}>{homeTeam}</p>
						<p className={css.teamName}>{guestTeam}</p>
					</div>
				)}
				<div className={css.teamInfosWrapper}>
					<div className={css.teamInfo}>
						<img className={css.logo} src={homeTeamLogo} alt={homeTeam} />
						{(isDesktop || isTablet) && <p className={css.teamName}>{homeTeam}</p>}
						<div className={css.resultedPlayers}>
							{resultedHomePlayers.map(event => renderPlayer(event))}
						</div>
					</div>
					<div className={css.scoreInfo}>
						{(homeScore !== 999 || questScore !== 999) && (
							<p className={css.score}>
								{homeScore}
								<span>:</span>
								{questScore}
							</p>
						)}

						{/* <p className={css.scoreTitle}>{scoreTitle}</p> */}
						<p className={css.refereeInfo}>
							{refereeTitle}
							{refereeName}
							{refereeGrade > 0 && (
								<>
									{' '}
									({refereeGradeTitle}
									{refereeGrade})
								</>
							)}
						</p>
					</div>
					<div className={css.teamInfo}>
						<img className={css.logo} src={guestTeamLogo} alt={guestTeam} />
						{(isDesktop || isTablet) && <p className={css.teamName}>{guestTeam}</p>}

						<div className={css.resultedPlayers}>
							{resultedGuestPlayers.map(event => renderPlayer(event))}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
